import { Card, CardHeader, CardBody, Link, Spinner } from '@heroui/react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router';

import { useReadEventMutation } from '@/patient-app-common/api/patientApi';
import { getURLParam } from '@/patient-app-common/utils';
import { useAppSelector } from '@/redux/hooks';

export function TaskAuth() {
  const { t } = useTranslation('login');
  const navigate = useNavigate();

  const [readEvent, { isLoading, isSuccess, isError }] = useReadEventMutation();

  const { route } = useAppSelector(({ app }) => app);

  const location = useLocation();
  const eventId = getURLParam(location.search, 'application_event_id');
  const title = getURLParam(location.search, 'title');
  const token = getURLParam(location.search, 'token');

  const submitReadEvent = async () => {
    const params = {
      token,
      eventId,
    };

    await readEvent(params);
  };

  useEffect(() => {
    if (!eventId) {
      navigate('/');
      return;
    }

    if (route === null || !token) return;
    submitReadEvent();
  }, [eventId, route, token]);

  return (
    <div className="flex flex-col items-center justify-center h-[100dvh]">
      <div className="sm:max-w-xl w-full">
        <Card shadow="sm" className="border border-grey px-4">
          <CardHeader>
            <h1 className="text-xl font-semibold mx-auto">{title}</h1>
          </CardHeader>
          <CardBody className="gap-4 items-center">
            {isLoading && (
              <>
                <Spinner className="m-4" color="primary" size="lg" />
                <p>{t('common.text.loading')}</p>
              </>
            )}

            {!isLoading && isSuccess && <p>{t('taskauth.response_success')}</p>}

            {!isLoading && isError && <p>{t('common.error.server')}</p>}

            <Link className="text-sm" href="/">
              {t('common.link.back_to_login')}
            </Link>
          </CardBody>
        </Card>
      </div>
    </div>
  );
}
